import React from 'react';
class ThumbNail extends React.Component {
  state = {
    loading: false,
    thumb: undefined,
    originalName: undefined,
  };
  componentDidMount() {
    if (!this.props.file) {
      return;
    }
    this.setState({ originalName: this.props.file.originalName });
  }

  componentWillReceiveProps(nextProps) {
    if (!nextProps.file) {
      return;
    }

    this.setState({ originalName: nextProps.file.originalName });
  }

  render() {
    const { file } = this.props;
    const { loading, thumb } = this.state;

    if (!file) {
      return null;
    }

    if (loading) {
      return <p>loading...</p>;
    }

    return <span>{this.state.originalName}</span>;
  }
}

export default ThumbNail;
